(() => {
  const initialize = () => {
    document.querySelectorAll('.ba-preview-header__buy').forEach((button) => {
      button.addEventListener('click', (event) => {
        const target =
          document.querySelector(button.getAttribute('href')) ||
          document.querySelector('basic-preset-builder, basic-bundle-builder, .product-form, [id^="ProductInfo-"]');
        if (!target) return;

        event.preventDefault();
        const menu = button.closest('.ba-preview-header')?.querySelector('.ba-preview-header__menu');
        if (menu) menu.open = false;

        window.requestAnimationFrame(() => {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (history.replaceState) history.replaceState(null, '', button.getAttribute('href'));
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
